import { UTM_MARKS } from 'constants/utmMarks';

export const isMarkValueNotSet = (name: ValuesOf<typeof UTM_MARKS>, value: unknown) => {
  if (UTM_MARKS.medium === name) {
    return value === '(none)';
  }
  return value === '(not set)';
};
